import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

import type { AiFeature } from '@vimeo/picox';

type GenerationIdMap = Record<AiFeature, string | null>;

const INITIAL_GENERATION_IDS: GenerationIdMap = {
  video_details: null,
  chapters: null,
  highlights: null,
  ask_ai: null,
  translate: null,
};

interface IAiGenerationState {
  generationIds: GenerationIdMap;
  startGeneration: (feature: AiFeature) => string;
  getGenerationId: (feature: AiFeature) => string | null;
  resetGeneration: (feature?: AiFeature) => void;
}

export const useAiGenerationStore = create<IAiGenerationState>()(
  devtools(
    (set, get) => ({
      generationIds: { ...INITIAL_GENERATION_IDS },

      startGeneration: (feature: AiFeature) => {
        const generationId = crypto.randomUUID();
        set(
          (state) => ({
            generationIds: { ...state.generationIds, [feature]: generationId },
          }),
          undefined,
          `aiGeneration/startGeneration:${feature}`,
        );
        return generationId;
      },

      getGenerationId: (feature: AiFeature) => get().generationIds[feature],

      resetGeneration: (feature?: AiFeature) => {
        if (feature) {
          set(
            (state) => ({
              generationIds: { ...state.generationIds, [feature]: null },
            }),
            undefined,
            `aiGeneration/resetGeneration:${feature}`,
          );
          return;
        }
        set(
          { generationIds: { ...INITIAL_GENERATION_IDS } },
          undefined,
          'aiGeneration/resetGeneration',
        );
      },
    }),
    {
      name: 'AiGenerationStore',
      enabled: process.env.NODE_ENV !== 'production' && typeof window !== 'undefined',
    },
  ),
);
